module.exports = __webpack_public_path__ + "fonts/DM_Sans-100-latin-ext2.49935c4.woff2";